import React from 'react'
import ReactDOM from 'react-dom';
import App from './components/app'
import WebFont from 'webfontloader'
import amplitude from 'amplitude-js'

WebFont.load({
    google: {
        families: ['Montserrat:700', 'Lato:400,700', 'Lora:400']
    }
});

if (!process.env.NODE_ENV || process.env.NODE_ENV === 'development') {    
    // amplitude.getInstance().init(require('./config.json').amplitudeKey)    
} else {
    amplitude.getInstance().init(require('./config.json').amplitudeKey)
    amplitude.getInstance().setVersionName(require('../package.json').version);
}

const root = document.getElementById('root')
ReactDOM.render(<App/>, root)